module.exports = __webpack_public_path__ + "static/img/step-2.92ad883.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/img/tuto-unlock-popup/chrome/step-2.png
// module id = 951
// module chunks = 0